import React, { Component } from "react";
import ReactTooltip from 'react-tooltip';
import LeftNavContent from '../../Commons/LeftNavContent';
import {Redirect, Link, NavLink} from 'react-router-dom'
import { 
  FacebookShareButton,
  VKShareButton,
  TwitterShareButton,
  GooglePlusShareButton,
  
  FacebookIcon,
  VKIcon,
  TwitterIcon,
  GooglePlusIcon
} from 'react-share';
import axios from 'axios';
import { connect } from 'react-redux';
import moment from 'moment';
import { getHeader } from "../../../helper";

import $ from "jquery";
window.jQuery = $;
require("@fancyapps/fancybox");

class ShareView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      currentPack: {},

      title: 'Альбом',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec dictum nibh accumsan, vehicula mauris vitae, lacinia orci. Aenean laoreet ornare ultrices. Vestibulum interdum suscipit felis sit amet molestie. Aliquam odio magna, tincidunt ut massa eu, congue ultricies purus. Cras vel erat dui. Fusce accumsan laoreet enim vitae blandit.',
      photos: [{ photo: 'http://writingexercises.co.uk/images2/randomimage/woodtextures.jpg' },
              {photo: 'http://writingexercises.co.uk/images2/randomimage/tree.jpg'},
              {photo: 'http://writingexercises.co.uk/images2/randomimage/fruit-stall.jpg'}],
      videos: [],

      tabIndex: 1
    }
  }

  componentWillMount() {
    const {id} = this.props.match.params;

    this.getProductById(id);
  }

  componentDidMount() {
    document.title = 'Fixfact';
  }

  getProductById(id, afterSuccess, afterError) {
    const {session:{isLoggedIn}} = this.props;
    let headers = isLoggedIn ? {headers:getHeader()} : {};

    axios.get(
      `${window.siteUrl}/api/v1/photo_video_pack/${id}/`, {
        params: {},
        headers: headers.headers
    })
    .then(response => {
        let currentPack = response.data;

        let isPhoto = currentPack.photos && currentPack.photos.length;
        let isVideo = currentPack.videos && currentPack.videos.length;

        this.setState({
          loading: false,
          currentPack: currentPack,
          tabIndex: (!isPhoto && isVideo) ? 2 : this.state.tabIndex
        })
      if(afterSuccess) afterSuccess(currentPack)
    })
    .catch(error => {
      this.setState({
        loading: false,
        error: error
      })
      if(afterError) afterError(error);
    })
  }

  onTabClick(index) {
    this.setState({ tabIndex: index });

    const {tab1, tab2} = this.refs;

    if(index === 1) {
      tab2 && tab2.classList.remove('selected');
      tab1 && tab1.classList.add('selected');
    } else {
      tab1 && tab1.classList.remove('selected');
      tab2 && tab2.classList.add('selected');
    }
  }

  renderPhotos() {
    const { currentPack:{photos} } = this.state;

    if(!photos || !photos.length) {
      return <p className='content-empty'>Нет фотографий</p>
    }

    return photos.map(photo => {
      return (
        <a className='tabs-content__item' key={photo.id} href={photo.image || photo.thumb_image} data-fancybox>
          <img src={photo.image || photo.thumb_image} alt='photo' data-tip data-for={`happyPhoto${photo.id}`}/>

          <ReactTooltip id={`happyPhoto${photo.id}`} type='dark'>
            <span style={{fontSize:'11px'}}>Дата загрузки: {photo.created_at ? moment(photo.created_at).format("DD.MM.YYYY HH:mm") : 'не указана'}</span>
          </ReactTooltip>
        </a>
      )
    })
  }

  renderVideos() {
    const { currentPack:{videos} } = this.state;
    
    if(!videos || !videos.length) {
      return <p className='content-empty'>Нет видео</p> 
    }

    return videos.map(video => {

      return (
        <div className='tabs-content__item' key={video.id}>

          {
            (video.video) ?
            <video className="pack-video" controls data-tip data-for={`happyVideo${video.id}`}>
              <source src={video.video} type="video/mp4"/>
              <source src={video.video} type="video/webm"/>
              <source src={video.video} type="video/ogg"/>
            </video>
            :
            <img src={video.thumb_image} alt='video' data-tip data-for={`happyVideo${video.id}`}/>
          }
         
          <ReactTooltip id={`happyVideo${video.id}`} type='dark'>
            <span style={{fontSize:'11px'}}>Дата загрузки: {video.created_at ? moment(video.created_at).format("DD.MM.YYYY HH:mm") : 'не указана'}</span>
          </ReactTooltip>
        </div>
      )
    })
  }

  renderContent() {

    const { currentPack:{photos, videos} } = this.state;

    let isPhoto = photos && photos.length ? true : false;
    let isVideo = videos && videos.length ? true : false;

    return (
      <div className='tabs'>
        <div className='tabs-header'>
          {
            isPhoto ?
            <h1 className={`tabs-header__item ${this.state.tabIndex ===  1 ? 'selected' : ''}`} ref='tab1' onClick={() => this.onTabClick(1)}>Фото</h1>
            : null
          }
          
          {
            isVideo ?
            <h1 className={`tabs-header__item ${this.state.tabIndex === 2 ? 'selected' : ''}`} ref='tab2' onClick={() => this.onTabClick(2)}>Видео</h1>
            : null
          }
        </div>
        <div className='tabs-content'>
          { this.state.tabIndex === 1 && this.renderPhotos() }
          { this.state.tabIndex === 2 && this.renderVideos() }
        </div>
      </div>
    )
  }

  render() {
    const {currentPack, loading} = this.state;

    if(this.state.loading) return <div></div>

    if(!currentPack || !currentPack.id) {
      return <Redirect to="/404"/>
    }

    return (
    
          <div className="vertical-scrolling page fourthSection sectionShareView" id="sectionShareView">
            <div className="container content">
              
            <LeftNavContent>
                <h2 className="left-content__title">
                    <span className="text_gradient_violet_circle disabled" style={{marginRight: "20px"}}>Покупка</span>
                    <span className="text_gradient_orange disabled">фотографий</span>
                </h2>

                <ul className="menu-content-nav">
                    <NavLink exact to="/buy/"> Все</NavLink>
                    <NavLink to="/buy/1"> Мои покупки</NavLink>
                    <NavLink to="/buy/2"> Мои продажи</NavLink>
                    <NavLink to="/buy/3"> Покупки юр. лица</NavLink>
                </ul>
            </LeftNavContent>

              <div className="right-content native-scroll right-content-bottom right-content-width">
                <div className="screen-outer-block-wrap native-scroll menu-content">
                  <div className="menu-content-share-view menu-content-item tab-parent screen-bottom-block">
                    <div className="rounded-white-block">
                      <div className="white-block-content">
                        <div className="white-block-top header-tab">
                          <h3>{currentPack.title || 'Название не указано'}</h3>
                        </div>
                        <div className="description" style={{padding:'15px'}}>
                          <div style={{textAlign:'left', fontSize:'13px'}}>
                            <div style={{marginBottom:'5px'}}>
                              {`Заказ: `}
                              <span style={{fontWeight:'bold', color:'#555'}}>
                                №{currentPack.order_id || ''} {currentPack.order_title || 'Название заказа не указана'}
                              </span>
                            </div>
                            <div style={{marginBottom:'5px'}}>
                              {`Дата загрузки: `}
                              <span style={{fontWeight:'bold', color:'#555'}}>
                                {currentPack.created_at ? moment(currentPack.created_at).format("DD.MM.YYYY HH:mm") : 'не указана'}
                              </span>
                            </div>
                            <div style={{marginBottom:'5px'}}>
                              {`Дата выполнения: `}
                              <span style={{fontWeight:'bold', color:'#555'}}>
                                {currentPack.order_finish_at ? moment(currentPack.order_finish_at).format("DD.MM.YYYY HH:mm") : 'Не указана'}
                              </span>
                            </div>
                          </div>
                          <p>{currentPack.description || 'нет описания'}</p>
                        </div>
                        <div className='photo-video'>
                          {this.renderContent()}
                        </div>
                        <div className='share' style={{justifyContent: 'space-between', alignItems: 'center'}}>
                          <div className='share__social' style={{display:'flex', flexDirection:'row'}}>
                            <FacebookShareButton
                              url={window.location.href}
                              quote={currentPack.order_title}
                              className="network__share-button">
                              <FacebookIcon
                                size={40}
                                round />
                            </FacebookShareButton>
                            <VKShareButton
                              url={window.location.href}
                              title={currentPack.order_title}
                              className="network__share-button">
                              <VKIcon
                                size={40}
                                round />
                            </VKShareButton>
                            <TwitterShareButton
                              url={window.location.href}
                              title={currentPack.order_title}
                              className="network__share-button">
                              <TwitterIcon
                                size={40}
                                round />
                            </TwitterShareButton>
                            <GooglePlusShareButton
                              url={window.location.href}
                              title={currentPack.order_title}
                              className="network__share-button">
                              <GooglePlusIcon
                                size={40}
                                round />
                            </GooglePlusShareButton>
                          </div>

                          <div style={{display:'flex', alignItems:'center', flexDirection: 'column', textAlign: 'right'}}>
                            <div className='share__author' style={{width:'100%', fontSize:'14px'}}>
                             <span>Автор:</span>  <Link style={{fontSize:'14px'}} to={`/profile/${currentPack.user.id}`}>{`${currentPack.user.first_name} ${currentPack.user.last_name}`}</Link>
                            </div>
                            {
                              currentPack.zip_archive ?
                              <a style={{marginTop: '15px',fontSize:'14px'}} href={currentPack.zip_archive}>Получить/скачать купленные результаты</a>
                             : null
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
    )
  }
}

export default connect(state => ({
  ...state
}))(ShareView);


// WEBPACK FOOTER //
// ./src/components/MakeOrder/OrderView/index.js